module.exports = __webpack_public_path__ + "static/media/swordmastery.9133812e.png";